export default "/images/vendor/@coreui/icons/svg/flag/cif-ne.svg?8886107f9b024cf14a53d4b3697ae7d2";